module.exports = __webpack_public_path__ + "img/input-search.62a527c1.svg";